export default {"src":"/_next/static/media/anxiety.e934007e.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};